import { useState } from "react";
import { toast } from "react-toastify";
import Loader from "../../components/Loader"; // Ensure the correct path
import { useNavigate } from "react-router-dom";
import Calling from "../../api/Calling"; // Replace with actual API calling function

export default function NewPw() {
    const [loader, setLoader] = useState(false);
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        setLoader(true);
        e.preventDefault();

        // Validate password length
        if (password.length < 6) {
            toast.error("Password must be at least 6 characters long", {
                autoClose: 2000,
            });
            setLoader(false);
            return;
        }

        // Validate password match
        if (password !== confirmPassword) {
            toast.error("Passwords do not match", {
                autoClose: 2000,
            });
            setLoader(false);
            return;
        }

        const body = {
            password: password,
        };

        try {
            const resp = await Calling.ResetPassword(body); // Replace with actual API call for password reset
            const { status, message } = resp;
            if (status) {
                toast.success(message, {
                    autoClose: 2000,
                });
                setTimeout(() => {
                    localStorage.removeItem('forgetPw');
                    navigate("/admin/panel/login"); // Replace with the actual route after password reset
                }, 2000);
            } else {
                toast.error(message, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            navigate('/Error');
        } finally {
            setLoader(false);
        }
    };

    return (
        <>
            {loader && <Loader />}

            <div className="min-h-screen flex items-center w-full justify-center back-Img">

                <title>New Password</title>
                <div className="bg-main-white p-8 rounded-lg shadow-md w-full max-w-md">
                    <h1 className="text-2xl font-bold text-primary-purple mb-6 text-center">
                        Set New Password
                    </h1>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-6">
                            <label htmlFor="password" className="block text-primary-blue">
                                New Password
                            </label>
                            <input
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full p-2 border border-main-border rounded mt-1  focus:ring-2 focus:ring-main-subfont  focus:outline-none"
                                required
                            />
                        </div>
                        <div className="mb-6">
                            <label htmlFor="confirmPassword" className="block text-primary-blue">
                                Confirm Password
                            </label>
                            <input
                                type="password"
                                id="confirmPassword"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                className="w-full p-2 border border-main-border rounded mt-1 focus:ring-2 focus:ring-main-subfont  focus:outline-none"
                                required
                            />
                        </div>
                        <button
                            type="submit"
                            className="w-full bg-primary-blue text-main-white py-2 px-4 rounded hover:bg-primary-purple focus:outline-none focus:ring-2 focus:ring-primary-purple"
                        >
                            Reset Password
                        </button>
                    </form>
                </div>
            </div>
        </>
    );
}
